module.exports = __webpack_public_path__ + "img/camera_down_selected.b28a63b4.svg";